/**
 * Keep <link rel="canonical"> and <meta property="og:url"> in sync with the current SPA route.
 * Called on every route change from ScrollToTop in App.js.
 */
const SITE_ORIGIN = "https://midemidelogistics.com";

export function updateCanonicalForPath(pathname) {
  if (typeof document === "undefined") return;
  const url = SITE_ORIGIN + (pathname || "/");

  // Canonical
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);

  // Open Graph URL
  let ogUrl = document.querySelector('meta[property="og:url"]');
  if (!ogUrl) {
    ogUrl = document.createElement("meta");
    ogUrl.setAttribute("property", "og:url");
    document.head.appendChild(ogUrl);
  }
  ogUrl.setAttribute("content", url);
}
